import HTMLReactParser from 'html-react-parser'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Colors } from 'styles/colors'
import './buttons.scss'

type RouteButtonProps = {
   title: string
   titleForCrumb?: string
   page: string
   background: string
   left?: string
   title2?: string
   title3?: string
   right?: string
   top?: string
   delay: number
   size: string
   bckType: string
   titleColor: string
   border?: string
   borderRadius?: string
   fingerColor?: string
   img?: string
}
export default function RouteButton(props: RouteButtonProps) {
   const {
      title,
      titleForCrumb,
      page,
      title2,
      title3,
      background,
      left,
      right,
      top,
      delay,
      size,
      bckType,
      titleColor,
      border,
      borderRadius,
      fingerColor,
      img,
   } = props
   const [opacity, setOpacity] = useState(0)
   const [positionLeft, setPositionLeft] = useState(left ? left : 0)
   const [positionRight, setPositionRight] = useState(right ? right : 0)
   const [positionTop, setPositionTop] = useState(top ? top : 0)
   const [fontSize, setFontSize] = useState('0px')
   const [margin, setMargin] = useState('')
   const addCrumb = {
      title: titleForCrumb ? titleForCrumb : title,
      page: page,
   }
   useEffect(() => {
      setOpacity(1)
      setTimeout(() => {
         setPositionRight(0)
         setPositionLeft(0)
         setPositionTop(0)
      }, delay)

      if (size >= '200px') {
         setFontSize('20px')
         setMargin('25px')
      }
      if (size >= '250px') {
         setFontSize('25px')
         setMargin('25px')
      }
      if (size >= '300px') {
         setFontSize('50px')
      }
      if (size >= '350px') {
         setFontSize('55px')
      }
      if (size >= '450px') {
         setFontSize('60px')
      }
   }, [delay, size])
   return (
      <>
         {title2 && title3 ? (
            <Link
               to={page}
               className='routeButton flex center'
               style={{
                  width: size,
                  height: size,
                  left: left && positionLeft,
                  right: right && positionRight,
                  top: top && positionTop,
                  opacity: opacity,
                  color: titleColor,
                  border: border && border,
                  borderRadius: borderRadius && borderRadius,
                  margin: margin,
                  backgroundImage:
                     bckType === 'image' ? `url("/background/${background}.jpg")` : '',
               }}
            >
               <div
                  className='partBtn'
                  style={{
                     width: size,
                     height: size,
                  }}
               >
                  <div
                     className='btnTitle h100 flex center'
                     style={{
                        backgroundColor: bckType === 'color' ? background : '',
                     }}
                  >
                     {HTMLReactParser(title)}
                     {img && (
                        <img className='img' src={`${process.env.PUBLIC_URL}/img/${img}`} alt='' />
                     )}
                  </div>
                  <div
                     className='btnTitle h100 flex center'
                     style={{
                        backgroundColor: bckType === 'color' ? background : '',
                     }}
                  >
                     {HTMLReactParser(title2)}
                     {img && (
                        <img className='img' src={`${process.env.PUBLIC_URL}/img/${img}`} alt='' />
                     )}
                  </div>
                  <div
                     className='btnTitle h100 flex center'
                     style={{
                        backgroundColor: bckType === 'color' ? background : '',
                     }}
                  >
                     {HTMLReactParser(title3)}
                     {img && (
                        <img className='img' src={`${process.env.PUBLIC_URL}/img/${img}`} alt='' />
                     )}
                  </div>
               </div>
            </Link>
         ) : (
            <Link
               to={page}
               className='routeButton flex center'
               style={{
                  width: size,
                  height: size,
                  left: left && positionLeft,
                  right: right && positionRight,
                  top: top && positionTop,
                  opacity: opacity,
                  color: titleColor,
                  border: border && border,
                  borderRadius: borderRadius && borderRadius,
                  margin: margin,
                  backgroundColor: bckType === 'color' ? background : '',
                  backgroundImage:
                     bckType === 'image' ? `url("/background/${background}.jpg")` : '',
               }}
            >
               <div className='btnTitle h100 flex center' style={{ fontSize: fontSize }}>
                  {HTMLReactParser(title)}
                  {title2 && !title3 && (
                     <div style={{ fontSize: '16px', marginTop: '10px' }}>
                        {HTMLReactParser(title2)}
                     </div>
                  )}

                  {img && (
                     <img className='img' src={`${process.env.PUBLIC_URL}/img/${img}`} alt='' />
                  )}
               </div>
               <img
                  className='finger'
                  src={`${process.env.PUBLIC_URL}/finger-${
                     fingerColor
                        ? fingerColor
                        : background === Colors.gris1
                          ? 'corail'
                          : background === Colors.corail
                            ? 'gris'
                            : 'white'
                  }.png`}
                  alt=''
               />
            </Link>
         )}
      </>
   )
}
